import { useEffect, useRef } from 'react';
/**
 * Пропускает первый эффект (повторяет поведение componentDidUpdate)
 * @param effect коллбэк эффекта
 * @param deps зависимости
 */

export const useUpdateEffect = (effect, deps) => {
  const isInitialRender = useRef(true);
  useEffect(() => {
    if (!isInitialRender.current) {
      effect();
    }

    isInitialRender.current = false; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};